import Partners from 'react-scale/components/pages/homepage/partners';
import Section from 'react-scale/components/ui/section';

const PreFooter = () => (
  <Section>
    <Partners text={false} thirdRow />
  </Section>
);
export default PreFooter;
